import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// After a new deploy, an open tab can try to load a page chunk that no longer exists.
// Reload once to pick up the current version instead of showing a blank page.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const key = 'adgs-chunk-reload';
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last < 10_000) return; // avoid reload loops
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // sessionStorage unavailable: still reload once
  }
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(<App />);
